import { Modal, Form, Row, Col } from "react-bootstrap";
import toggleNetworkRequestStatus from "../../actions/toggleNetworkRequestStatus";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { loadData } from "../../actions/scheduleListingAction";
import { renderGlobalModal } from "../../utils/helpers";
import PropTypes from "prop-types";

const ReasonModal = ({ status, reasonShow, handleClosePopover, listingData }) => {

    const { register, handleSubmit, formState: { errors } } = useForm();
    const dispatch = useDispatch()
    const onSubmit = (data) => {
        dispatch(toggleNetworkRequestStatus(true));
        const request = {};
        request.reason = data?.reason
        request.status = status
        request.id = listingData?.id
        agent.post(API.LOAD_CUSTOMER + "/web-update-meeting-status", request).then((res) => {
            renderGlobalModal({ message: res?.data?.message })
            dispatch(toggleNetworkRequestStatus(false));
            dispatch(loadData({}))
            handleClosePopover()
        }).catch((err) => {
            renderGlobalModal({ message: err.message || "Something went wrong.Please try again." });
            dispatch(toggleNetworkRequestStatus(false));
            dispatch(loadData({}))
            handleClosePopover()
        });
    };

    return (
        <Modal show={reasonShow} onHide={handleClosePopover} centered className="calendar-modal">
            <Modal.Header closeButton>
                <Modal.Title>
                    {status == "Cancelled" ? "Reason for Cancel" : ""}
                    {status == "Rescheduled" ? "Reason for Reschedule" : ""}
                    {status == "Requested_For_Reschedule" ? "Reason for Reschedule" : ""}
                    {status == "Rejected" ? "Reason for Reject" : ""}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="mentor_detail align-items-center">
                        <Col sm={12} className="mb-4">
                            <label className="form-label" htmlFor="reason">Reason *</label>
                            <Form.Control
                                as="textarea"
                                className={
                                    errors.reason ? "form-control is-invalid" : "form-control"
                                }
                                name="reason"
                                aria-invalid={errors.reason ? "true" : "false"}
                                {...register("reason", {
                                    required: {
                                        value: true,
                                        message: "Please enter reason.",
                                    },
                                    minLength: 0,
                                    maxLength: 255,
                                    validate: (value) => {
                                        if (value.trim() == "") {
                                            return "Please enter reason.";
                                        } else {
                                            return true;
                                        }
                                    },
                                })}
                            />
                            {errors?.reason?.message && (
                                <label className="customeValidationText text-left" htmlFor="reason">
                                    {errors?.reason?.message}
                                </label>
                            )}
                            {errors?.reason &&
                                errors.reason?.type === "minLength" && (
                                    <label className="customeValidationText text-left" htmlFor="reason">
                                        Reason should contain at least 1
                                        characters.
                                    </label>
                                )}
                            {errors?.reason &&
                                errors.reason?.type === "maxLength" && (
                                    <label className="customeValidationText text-left" htmlFor="reason">
                                        Reason should not exceed 255 characters.
                                    </label>
                                )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div className="form-group mt-3 text-left">
                                <button
                                    className="btn loginsubmit nextbtn ml-2 btn_red"
                                    type="submit"
                                >
                                    Ok
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

ReasonModal.propTypes = {
    handleClosePopover: PropTypes.func.isRequired,
    listingData: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    reasonShow: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
};

export default ReasonModal;